import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appIntegerOnly]',
})
export class IntegerOnlyDirective {
  constructor() {}
  @HostListener('input', ['$event.target'])
  onInput(input: HTMLInputElement) {
    const value = input.value;
    input.value = value.replace(/[^0-9]/g, '');
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (['Backspace', 'Tab', 'Enter', 'Escape', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) > -1) {
      return;
    }

    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
}
